import React, { memo } from "react"
import PropTypes from "prop-types"
import { Button } from "antd"
import moment from "moment"
import { getEventColor } from "pagesV2/pro/Calendar/utils"
import { useTheme } from "context/AntdThemeContext"
import {
  getDefaultCalendarColor,
  getEventPreviewColors,
  getPrimaryCalendarTextColor
} from "pagesV2/pro/Calendar/calendarColorUtils"
import styles from "./index.module.css"
import BookingConflictWarning from "pagesV2/pro/Calendar/Tooltips/BookingConflictWarning"

const BookingItem = ({ booking, conflict = false, setIsBookingModalOpen, setSelectedBookingId, compact = false }) => {
  const { start_time, end_time, uuid, experience_name, color } = booking || {}
  const { theme } = useTheme()
  const formattedTime = (t) => (t ? moment(t, ["HH:mm:ss", "HH:mm", "h:mm A", "hh:mm A"]).format("h:mm A") : "")
  let eventTime = formattedTime(start_time)
  if (end_time) {
    eventTime += (eventTime ? " - " : "") + formattedTime(end_time)
  }
  const resolvedColor = getEventColor(color)
  const isCustomColor = resolvedColor?.startsWith("#")
  const primaryTextColor = getPrimaryCalendarTextColor(theme)
  const defaultColor = getDefaultCalendarColor()
  const previewColors = isCustomColor
    ? getEventPreviewColors(resolvedColor, defaultColor, primaryTextColor)
    : {
      backgroundColor: resolvedColor,
      borderColor: primaryTextColor,
      textColor: primaryTextColor
    }

  const handleBookingClick = () => {
    setIsBookingModalOpen(true)
    setSelectedBookingId(uuid)
  }

  return (
    <Button
      type="link"
      className={`${compact ? styles.bookingBlockCompact : ""} ${styles.bookingBlock}`}
      style={{ backgroundColor: previewColors.backgroundColor, borderColor: previewColors.borderColor }}
      onClick={handleBookingClick}
    >
      {eventTime && (
        <div className={styles.timeRow}>
          <span
            className={compact ? styles.timeTextCompact : styles.timeText}
            style={{ color: previewColors.textColor || primaryTextColor }}
          >
            {eventTime}
          </span>
          {conflict ? <BookingConflictWarning /> : null}
        </div>
      )}
      <span
        className={compact ? styles.titleTextCompact : styles.titleText}
        style={{ color: previewColors.textColor || primaryTextColor }}
      >
        {experience_name}
      </span>
    </Button>
  )
}

BookingItem.propTypes = {
  booking: PropTypes.shape({
    id: PropTypes.string.isRequired,
    uuid: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    payment_status: PropTypes.string,
    title: PropTypes.string.isRequired,
    formatted_start_time: PropTypes.string,
    formatted_end_time: PropTypes.string
  }).isRequired,
  conflict: PropTypes.bool,
  setIsBookingModalOpen: PropTypes.func,
  setSelectedBookingId: PropTypes.func,
  compact: PropTypes.bool,
}

export default memo(BookingItem)
